<!-- Current Plan Info -->
<div class="plan-info">
  <div class="plan-type plan-info-item" *ngIf="plan_type">
    <span>Current Plan: </span>&nbsp;<span class="bold">{{ plan_type | titlecase }}</span>
  </div>
  <div class="plan-date plan-info-item" *ngIf="plan_end_date">
    <span>Renewal Date: </span>&nbsp;<span class="bold">{{ plan_end_date | date }}</span>
  </div>
  <div class="contact-sales plan-info-item">
    <span>Contact sales</span>
  </div>
</div>
<div class="chart-row">
    <!-- Chart : Registered traffic per month -->
    <mat-card id="visitor-traffic-chart-container" class="traffic-chart-container">
      <mat-card-title class="card-title">
        <div class="title">Active Registered Visitors per month</div>
      </mat-card-title>
      <mat-card-content *loading="visitorTrafficDataStatus">
          <google-chart *ngIf="visitorTrafficChart" [data]="visitorTrafficChart" ></google-chart>
      </mat-card-content>
    </mat-card>
    <mat-card id="most-active-creators" >
      <mat-card-title class="card-title">
        <div class="title">Most Active Creators</div>
      </mat-card-title>
      <mat-card-content *loading="mostActiveCreatorsLoadStatus">
        <table *ngIf="mostActiveCreators" class="most-active-creators-table">
          <tr *ngFor="let user of mostActiveCreators">
              <td class="row-content"> <mat-icon>account_circle</mat-icon><span class="title">{{ user?.first_name }} - {{ user.n_courses }}</span></td>
          </tr>
      </table>
      </mat-card-content>
    </mat-card>
</div>
<div class="chart-row">
  <mat-card id="sessions-traffic-chart-container" class="traffic-chart-container" >
    <mat-card-title class="card-title">
      <div class="title">Sessions per month</div>
    </mat-card-title>
    <mat-card-content *loading="sessionTrafficDataStatus">
        <google-chart *ngIf="sessionTrafficChart" [data]="sessionTrafficChart" (chartReady)="drawLegend()"></google-chart>
        <google-chart-legend *ngIf="sessionTrafficChartLegend" [legend]="sessionTrafficChartLegend"></google-chart-legend>
    </mat-card-content>
  </mat-card>
    <mat-card id="course-creation-chart-container" class="traffic-chart-container">
        <mat-card-title class="card-title">
          <div class="title">{{ hub.mode | courseLabel:true | titlecase }} creations per month</div>
        </mat-card-title>
        <mat-card-content *loading="courseCreationsDataStatus">
            <google-chart *ngIf="courseCreationChart" [data]="courseCreationChart"></google-chart>
        </mat-card-content>
      </mat-card>


</div>
